/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobInvalidation {
    getFixupPrototypeFunction() { return BackgroundJobInvalidation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobInvalidation>): BackgroundJobInvalidation {
        let obj = Object.assign(new BackgroundJobInvalidation(), model);
        BackgroundJobInvalidation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobInvalidation>): BackgroundJobInvalidation {
        if (!model) return null;
        return BackgroundJobInvalidation.newInstance(<BackgroundJobInvalidation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobInvalidation) {
        if (!obj) return;

        models.BackgroundJobInvalidation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobInvalidation): boolean {
        Object.setPrototypeOf(obj, BackgroundJobInvalidation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.sent_at === "string") {
            this.sent_at = new Date(<string><any>this.sent_at);
        }
        if (this.jobs) {
            for (let val of this.jobs) {
                models.BackgroundJobIdentityWithStatus.fixupPrototype(val);
            }
        }
    }

    /**
     * When the invalidation message was created
     */
    created_at: Date;

    /**
     * When the invalidation message was sent
     */
    sent_at: Date;

    /**
     * Sources of the event
     */
    executors: Array<models.BackgroundJobExecutor>;

    /**
     * Job context
     */
    jobs: Array<models.BackgroundJobIdentityWithStatus>;

    /**
     * Domain context
     */
    domains: Array<string>;

}
